import { createTheme } from "@mui/material/styles";

/** Simple light theme for the journal app. */
export const appTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1a1a1a",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#555555",
    },
    background: {
      default: "#fafafa",
      paper: "#ffffff",
    },
    text: {
      primary: "#1a1a1a",
      secondary: "#666666",
    },
    divider: "#e8e8e8",
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily:
      '"IBM Plex Sans", "Source Sans 3", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h4: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "8px 18px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          color: "#1a1a1a",
        },
      },
    },
  },
});
